import { useTranslation } from "react-i18next";
import { Loader2Icon, type LucideProps } from "lucide-react";

import { cn } from "@/lib/utils";

interface SpinnerProps extends LucideProps {
  size?: number | string;
}

function Spinner({ className, size = 16, ...props }: SpinnerProps) {
  const { t } = useTranslation();

  // Map common size aliases to numeric values if needed
  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 24 : size;

  return (
    <Loader2Icon
      role="status"
      aria-label={t('common.loading', 'Loading')}
      size={iconSize}
      className={cn("animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
